import Vue from 'vue';

const state = {
    items: [],
};

const mutations = {
    changeTariffParams(state, items) {
        state = Object.assign(state, items)
    }
};

const getters = {
    getTariffsItems: (state, getters) => {
        let items = state.items.filter(item => {
            if (item.city === getters.getUserCity.value || item.city === 0)
                return item;
        });
        return items;
    },
    getTariffsSelectItems: (state, getters) => {
        let items = [];
        state.items.forEach(item => {
            if (item.city === getters.getUserCity.value || item.city === 0) {
                items.push({value: item.id, text: item.title});
            }
        });
        return items;
    },
    getTvTariffs: (state, getters) => {
        let items = state.items.filter(item => {
            if (item.services === null)
                return false;
            if (item.services.length === 0)
                return false;
            if (item.visible === 0)
                return false;
            if (item.services.split(",").indexOf('tv') !== -1
                && item.services.split(",").indexOf('inet') === -1
                && (item.city === getters.getUserCity.value || item.city === 0))
                return item;
        });
        return items;
    },
    getInternetTariffs: (state, getters) => {
        let items = state.items.filter(item => {
            if (item.services === null)
                return false;
            if (item.services.length === 0)
                return false;
            if (item.visible === 0)
                return false;
            if (item.services.split(",").indexOf('tv') === -1
                && item.services.split(",").indexOf('inet') !== -1
                && (item.city === getters.getUserCity.value || item.city === 0))
                return item;
        });
        return items;
    },
    getPacketTariffs: (state, getters) => {
        let items = state.items.filter(item => {
            if (item.services === null)
                return false;
            if (item.services.length === 0)
                return false;
            if (item.visible === 0)
                return false;
            if (item.services.split(",").indexOf('tv') !== -1
                && item.services.split(",").indexOf('inet') !== -1
                && (item.city === getters.getUserCity.value || item.city === 0))
                return item;
        });
        return items;
    },
};

const actions = {
    setTariffItems({commit}) {
        commit('createProcess', 'tariffs');
        Vue.http.get(this.getters.getApiUrl + 'v1/tariffs?filter[archive]=0&sort=sort&per-page=1000').then(response => {
            commit('changeTariffParams', {items: response.data});
            commit('setProcessSuccess', 'tariffs');
        }, response => {
            commit('setProcessFailed', {id: 'tariffs', message: response.body.message});
        });
    }
};

export default {
    state,
    getters,
    actions,
    mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/tariffs.js